import React, { useEffect } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";

function AboutUs() {
    useEffect(() => {
        document.title = "About Us - CARMEL CONVENT SCHOOL, DHARUHERA";
    }, []);

    return (
        <>
            <Header />

            <div className="sliderbg"></div>

            <div className="innerpage">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <ul className="breadcrumbli">
                                <li>
                                    <Link to="/">Home</Link>
                                </li>
                                <li>Coming Soon
                                </li>
                            </ul>
                        </div>

                        <div className="col-lg-12">
                            <h2 className="innerheading">Coming Soon
                            </h2>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="coming-soon">
                                <h2>Coming Soon</h2>
                                <p>
                                    We are currently working on this page.
                                    <br />
                                    Please check back soon.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
}

export default AboutUs;